import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/GetApp';

export function DownloadButtonPublic({ document }) {
  const handleAction = async () => {
    const result = await fetch(document.url);
    const blob = await result.blob();
    const href = window.URL.createObjectURL(blob);
    const link = window.document.createElement('a');

    link.download = document.name;
    link.href = href;
    link.click();
    window.setTimeout(() => window.URL.revokeObjectURL(href), 0);
  };

  return (
    <Button
      className="download-button-public"
      variant="contained"
      size="small"
      startIcon={<SaveIcon />}
      onClick={handleAction}
    >
      {document.name}
    </Button>
  );
}
